import dynamic from 'next/dynamic'
import { useMemo } from 'react'
import { useAdminCookie } from '../../contexts'
import { ChildrenWrap } from './Style'

const AdminBarComp = dynamic(() => import('./AdminBar'), { ssr: false })
const EditBLockComp = dynamic(() => import('./EditBLock'), { ssr: false })

type Props = {
  grid_id?: number | string
  type?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: JSX.Element | null
  anchorId?: string
  site?: 'ott' | 'portal'
}

export const EditMe = ({ grid_id, type, children, anchorId }: Props) => {
  const admin_cookie = useAdminCookie()

  return useMemo(() => {
    if (!(grid_id && admin_cookie)) {
      return children || null
    }

    if (type === 'admin-bar') {
      return (
        <>
          <AdminBarComp key={'AdminBarComp'} />
          {children}
        </>
      )
    } else {
      return (
        <>
          <EditBLockComp grid_id={grid_id} anchorId={anchorId} />
          <ChildrenWrap>{children}</ChildrenWrap>
        </>
      )
    }
  }, [admin_cookie, anchorId, children, grid_id, type])
}
